import { MenuIdHome } from '@jira/navigation-apps__constants/src/MenuIdHome.tsx';
import { LazyHorizontalOperationsNav } from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { opsReportingConfigResource } from '@jira/router-resources__ops-reports/src/opsReportingConfigResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { eocGlobalReportsNewRoute } from '@jira/router-routes__eoc-reports-new-routes/src/eocGlobalReportsNewRoute.tsx';
import { opsMigrationHubLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { operationsReportsShellEntrypoint } from '@jira/eoc__ops-reports-new/src/operationsReportsShell.entrypoint.tsx';
import { resources as opsReportsResources } from '@atlassian/eoc-ops-reports-common/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';

const entryPoint = createPageEntryPoint({ main: operationsReportsShellEntrypoint });

export const eocGlobalReportsNewRouteEntry: Route = createEntry(
	eocGlobalReportsNewRoute,

	() => ({
		group: 'eoc',
		layout: opsMigrationHubLayout,
		entryPoint: () => entryPoint,

		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		resources: [
			...getNavigationResources(),
			...opsReportsResources(),
			getConsolidationStateResource(),
			opsReportingConfigResource,
		] as RouteResources,

		navigation: {
			menuId: MenuIdHome,
		},

		forPaint: [LazyHorizontalOperationsNav, LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
